"use client"

import { lazy, Suspense, type ComponentType, type LazyExoticComponent } from "react"

import { SuffixProvider } from "./SuffixContext"
import type { AdComponentTypes, AdListType } from "./types"

export enum PosTypeEnum {
  ONEIMG = "单张图片",
  TEXT = "文字",
  RICHTEXT = "富文本",
  TILEIMG = "图片平铺",
  SWIPER = "图片轮播",
  EXPANSION = "扩充广告",
  COUPLET = "对联",
  VIDEO = "视频",
}

type AdVariant = LazyExoticComponent<ComponentType<AdComponentTypes>>

const adVariants: Record<PosTypeEnum, AdVariant> = {
  [PosTypeEnum.ONEIMG]: lazy(() => import("./_components/OneImg")),
  [PosTypeEnum.TEXT]: lazy(() => import("./_components/Text")),
  [PosTypeEnum.RICHTEXT]: lazy(() => import("./_components/RichTxt")),
  [PosTypeEnum.TILEIMG]: lazy(() => import("./_components/TileImg")),
  [PosTypeEnum.SWIPER]: lazy(() => import("./_components/Swiper")),
  [PosTypeEnum.EXPANSION]: lazy(() => import("./_components/Expansion")),
  [PosTypeEnum.COUPLET]: lazy(() => import("./_components/Couplet")),
  [PosTypeEnum.VIDEO]: lazy(() => import("./_components/Video")),
}

/**
 * 广告组件props
 * @param AdList 广告数据
 * @param style 样式
 * @param suffix 后缀
 */
export interface AdComponentProps {
  /** 广告数据 */
  AdList: AdListType
  /** 样式 */
  style?: React.CSSProperties
  /** 广告位图片后缀 */
  suffix?: string
}

const AdComponent = (props: AdComponentProps) => {
  const { AdList, style, suffix } = props
  const Variant = adVariants[AdList.pos_type as PosTypeEnum] ?? adVariants[PosTypeEnum.TEXT]

  return (
    <SuffixProvider suffix={suffix || ""}>
      <Suspense fallback={null}>
        <Variant AdList={AdList} style={style} />
      </Suspense>
    </SuffixProvider>
  )
}
export default AdComponent
